export default {
  product: {
    shareButton: 'Teilen',
    seeAllImages: 'Alle Fotos anzeigen',
    eventsFromTheSameSupplier: 'Veranstaltungen vom selben Anbieter',
    similarEvents: 'Ähnliche Aktivitäten',
    similarCourseEvents: 'Entdecke ähnliche Kurse in Deiner Nähe',
    similarTourEvents: 'Entdecke ähnliche Touren in Deiner Nähe',
    similarExperienceEvents: 'Entdecke ähnliche Erlebnisse in Deiner Nähe',
    similarOnlineEvents: 'Ähnliche Online Kurse und Workshops',

    boxEventLabel: 'Boxen',
    boxSimilarLabel: 'Entdecke ähnliche DIY-Boxen',
    boxSimilarLabelOnEventPage: 'Entdecke unsere DIY-Boxen',
    giftcardEventsFromTheSameSupplier: 'Andere Gutscheine entdecken',
    giftcardSimilarEvents: 'Beliebte Kurse für Deinen Gutschein',
    giftcardSimilarOnlineEvents: 'Beliebte Online Kurse für Deinen Gutschein',

    promo: {
      giftcard: 'Verschenke Zeit; {eventCount} Erlebnisse; Geschenkboxen',
      teamevent: 'Teamevents; Private Gruppen; Firmenfeiern',
    },

    sale: {
      daysLeft: 'nur noch {daysLeft} Tage!',
      hoursLeft: 'nur noch ein paar Stunden!',
    },

    showcase: {
      showMore: 'Mehr anzeigen',
      showLess: 'Weniger anzeigen',
    },

    gallery: {
      shareModal: {
        shareEventTitle: 'Dieses Event teilen',
        shareGiftcardTitle: 'Diesen Geschenkgutschein teilen',
        copyLinkButton: 'Link kopieren',
        copiedLinkButton: 'In Zwischenablage kopiert',
        shareEventMessage:
          'Hier ist ein Event, das ich bei konfetti gefunden habe',
        shareGiftcardMessage:
          'Hier ist ein Geschenkgutschein, den ich bei konfetti gefunden habe',
        shareEventSubject: 'Schau Dir folgendes Event an',
        shareGiftcardSubject: 'Schau Dir diesen Geschenkgutschein an',
      },
    },

    dateRequest: {
      sidebarTitle: 'Jetzt unverbindlich anfragen!',
      sidebarSuccessTitle: 'Jetzt unverbindlich anfragen!',

      eventSuggestions: {
        title: 'Weitere Kurse, die Dich interessieren könnten',
        requestSent: 'Deine Anfrage wurde abgesendet',
        seeMoreButton: 'Weitere Kurse entdecken',
        seeMoreNotification: 'Hier sind weitere Vorschläge für Dich',
        cantBeHeldAtCustomLocation:
          'Bitte beachte, dass bei kleinen Gruppen das Event in der Location des Veranstalters stattfindet.',
      },

      generalSuccessMessage:
        'Deine Anfrage war erfolgreich – Du kannst Dich nun zurücklehnen! Unser Team meldet sich in den nächsten 24h bei Dir!',
      generalSuccessShareEventButton: 'Dieses Event teilen',
    },

    status: {
      soldOut: 'Ausverkauft',
      open: 'Verfügbar',
      expired: 'Geschlossen',
      fewTicketsLeft: 'Wenige Tickets',
    },

    reviews: {
      reviewAmountLabel: 'Neu | {n} Bewertung | {n} Bewertungen',
      ratingLabel: 'Neu | {n} | {n} ',
      newEventLabel: 'Neu',
      supplierVerifiedLabel: 'Geprüfter Partner',
      readMoreLabel: 'mehr lesen',
      reviewSectionSubtitle:
        'Neu | Basierend auf {n} Bewertung | Basierend auf {n} Bewertungen',
    },
    show: {
      calendarNoDates: {
        title: 'Derzeit sind keine weiteren Termine verfügbar',
        description: {
          waitlist:
            'Keine weiteren Termine verfügbar. Tragen Sie sich in die Warteliste für zukünftige Updates ein.',
          waitlistAndDateRequest:
            'Keine weiteren Termine verfügbar. Auf die Warteliste setzen oder einen bestimmten Termin anfragen.',
          dateRequest:
            'Keine weiteren Termine verfügbar. Terminanfrage für ein bestimmtes Datum.',
          general:
            'Keine weiteren Termine verfügbar. Versuchen Sie, eine private Veranstaltung anzufragen oder uns per Chat zu kontaktieren.',
        },
      },
      timeSlots: {
        privateBadgeText: 'Privat',
        sellingOutBadgeText: 'Wenige Tickets',
      },
      datePickerCaptions: {
        publicDateLabel: 'Öffentlich',
        privateDateLabel: 'Private Gruppen',
        soldOutLabel: 'Ausverkauft',
      },
      noAvailableDatesBox: {
        title: 'Mehr Termine in Kürze',
        altTitle: 'Für neue Termine benachrichtigt werden',
        ctaTextOnlyProposeDate: 'Anfragen',
        ctaTextOnlyWaitlist: 'Warteliste',
        tooltipText:
          'Termine anfragen oder auf Warteliste für neue Termine eintragen',
      },

      infoBanner: {
        private: 'Du buchst als private Gruppe',
        public: 'Du buchst die öffentliche Veranstaltung',
        multidate: 'Du buchst ein Event mit mehreren Terminen',
        box: 'Die Box wird zu Dir nach Hause geliefert',
        atYourLocation: 'an Ihrem Standort',
        privateToggleLabel:
          'als private Veranstaltung buchen {privateEventExtraPrice}',
        duration: 'Dauer:',
        people: {
          notProvided: 'keine Information',
          minOnly: 'ab {n} Personen',
          maxOnly: 'Bis {n} Teilnehmer',
          same: 'für {n} Personen',
          range: '{min} - {max} Personen',
        },
      },

      icons: {
        duration: 'Dauer',
        whatsIncluded: 'Welche Leistungen inklusive sind',
        teamEventsAndGiftCards: 'Teamevents und private Gruppen',
        locationSummary: 'Standort',
        languages: {
          title: 'Sprachen',
          list: {
            de_DE: 'Deutsch',
            en_US: 'Englisch',
            pt_BR: 'Portugiesisch',
            es_ES: 'Spanisch',
            ja_JP: 'Japanisch',
            fr_FR: 'Französisch',
          },
        },

        mobileEvent: {
          title: 'Wunschlocation',
          content: 'Auch in Deiner Location möglich',
        },
      },

      giftcardIcons: {
        duration: 'Termine',
        durationContent: 'Flexible Terminwahl rund ums Jahr',
        whatsIncluded: 'Das optimale Geschenk für',
        whatsIncludedContent: 'Gustschein für einen Kochkurs Deiner Wahl',
        teamEventsAndGiftCards: 'Wofür der Gutschein einlösbar ist',
        teamEventsAndGiftCardsContent: 'Auch für private Events gültig',
        locationSummary: 'Locations',
        locationContent: 'Unsere Location findest Du unten auf der Karte',
        multipleLocationsSummary:
          'Details zur Location erhältst Du vom Veranstalter nach der Buchung',
        languages: {
          title: 'Sprachen',
          content: 'Deutsch, Englisch',
        },
      },

      privateEventInfo: {
        title: 'Wie funktioniert ein privates Event?',
      },

      basicDetails: {
        description: 'Über diese Aktivität',
        giftcardDescription: 'Die wichtigsten Infos zum Gutschein',
        detailsToRemember: 'Wichtige Details',
        whatToBring: 'Was Du zur Tour mitbringen solltest',
        giftcardWhatToBring: 'Das beinhaltet der Gutschein',
        whatIsIncluded: 'Was bei der Tour inklusive ist',
        giftcardWhatIsIncluded: 'So erhältst Du den Gutschein',
        courseProgress: 'Wie läuft die Tour ab?',
        courseTarget: 'Wer sollte an der Tour teilnehmen?',
      },

      boxDetails: {
        description: 'Über diese Box',
        courseProgress: 'Dieses Erlebnis erwartet Dich in der Box',
        courseTarget: 'Für wen ist diese Box geeignet?',
        detailsToRemember: 'Wichtige Details',
        whatToBring: 'Was Du sonst benötigst',
        whatIsIncluded: 'Was die Box beinhaltet',
        summaryWhatIsIncluded: 'Was ist in der Box?',
        summaryMoreDetails: 'Mehr Details',
        buyBoxQuantity: 'Box kaufen',
        buyBoxQuantityHelperText: 'Teile uns die gewünschte Anzahl mit',
        locationHomeTitle: 'Erlebnis für Zuhause',
        locationHomeDescription:
          'Deine Box kommt per Post: komplett vorbereitet und sofort startklar.',
      },

      map: {
        title: 'Tourverlauf',
        showMore: 'Komplette Route ansehen',
        address: 'Adresse: Hier findet der Kurs statt.',
      },

      checkout: {
        allDay: 'Jederzeit',
        quantity: 'Jetzt Tickets sichern',
        onlyNTicketsLeft: 'nur noch {n} Tickets übrig',
        time: 'Zeitfenster',
        privateQuantity: 'Anzahl Teilnehmer',
        privateQuantityPlaceholder: 'Auswählen',
        triedToAddBeyondMaxTickets:
          'Geringe Verfügbarkeit: Event anfragen oder Datum ändern',
        triedToAddBelowMinTickets:
          'Kleinere Gruppen zahlen den Preis von {minQty} Personen',
        tryDateRequestButtonText: 'Event anfragen',
        privateQuantityNoTicketsSelected:
          'Teile uns die Anzahl der Teilnehmer mit',
        book: 'In den Warenkorb',
        bookGiftcard: 'Als Gutschein kaufen',
        selectDate: 'Termin auswählen',
        availableTimes: 'Termin auswählen',
        noMoreDatesAvailable: 'Mehr Termine bald verfügbar',
        giftcard: {
          sectionTitle: 'Gutschein kaufen für',
          discountLabel: 'Vorheriger Preis',
          infoBannerText: 'Neue Termine in Kürze!',
          giftExperiences: 'Gutschein zum Selbstausdrucken',
          forAnyKonfetti: 'Einlösbar für über {eventCount} konfetti Erlebnisse',
          validity: 'Ab Kauf 3 Jahre lang gültig',
        },
        embeddedGiftcard: {
          iconsLabels: {
            first: 'Ab Kauf 3 Jahre lang gültig',
            second: 'Beschenkte wählt Kurs und Termin',
            third: 'Spaß garantiert :)',
          },
        },

        teamEvent: {
          title: 'Teamevent anfragen',
          boxTitle: 'Boxen anfragen',
          titleWithPrice: 'Ticket ab {price} pro Person',
          description:
            'Individuelle Termine anfragen. Auch für Firmenevents oder private Gruppen. Unverbindliches Angebot erhalten.',
          boxDescription:
            ' Mehrere Boxen für Dein Event anfragen. Auch für Firmenevents oder private Gruppen. Erhalte ein unverbindliches Angebot.',
          contactUs: 'Teamevent anfragen',
        },
        info: {
          publicEvent:
            'Buche ein oder mehrere Tickets für einen öffentlichen Kurs.',
          privateEvent:
            'Buche den Kurs für eine private Gruppe und gebe die Anzahl der Teilnehmer ein. Der Preis pro Gruppe startet bei {price}.',
          giftcard:
            'Der Gutschein kann für alle Kurse eingelöst werden und ist 3 Jahre gültig.',
        },

        shipping: {
          excludingShipping: 'exkl. Versand',
          productCardInfo: 'zzgl. Versand',
        },
        buyBoxPrivateBadge: 'Privat',
        buyBoxPrivateQuantityHelperText: 'Jedes Ticket gilt für eine Person',
        pricePrivateSubtitle: '{price} pro Ticket',
      },
    },

    card: {
      duration: 'Dauer: {duration}',
      durationDefaultContent: 'auf Anfrage',
      mobileClasses: 'Auch bei Dir',
      productBox: 'Box',
      sale: 'Sale',
      price: {
        teamevent: `ab {price} p.P.`,
      },
    },

    teamEventsForm: {
      title: 'Jetzt unverbindlich anfragen!',
      noscript:
        "Falls Du kein Formular siehst, wird dieses durch die Einstellungen Deines Browsers oder Adblocker blockiert. Nutze einen anderen Browser oder schreibe uns an hallo{'@'}gokonfetti.com",
    },

    preview: {
      alert: {
        title: 'Dies ist eine Vorschau',
        content: 'Dies ist eine Vorschau und das Event ist nicht indexiert.',
      },
    },

    subscribeToEventUpdatesModal: {
      requestDateButtonLabel: 'Konkreten Termin anfragen',
      firstStep: {
        title: 'Kein passender Termin dabei?',
        description:
          'Trage Dich jetzt auf die Warteliste ein und werde bei neuen Terminen automatisch benachrichtigt.',
        dateRequestTitle: 'Neue Termine anfragen',
        submitButtonLabel: 'Warteliste beitreten',
        finishedButton: 'Weiter stöbern',
        requestDatesButtonLabel: 'Abschicken',
        requestDatesDoneButtonLabel: 'Anfrage gesendet',
        waitlistSectionTitle: 'Auf Warteliste eintragen',
        waitlistSectionTitleTooltip:
          'Trage Deine E-Mail ein und wir melden uns wenn es neue Termine gibt.',
        requestDatesSectionSubtitle: 'Schlage bis zu drei Termine vor',
        requestDateFormat: 'DD.MM.YYYY HH:mm',
        requestDatesDescription: 'Je mehr Terminvorschläge desto besser.',
        form: {
          email: {
            label: 'E-Mail',
            placeholder: "erika{'@'}mustermann.de",
          },
          phone: {
            label: 'Telefon für Rückfragen',
            placeholder: '+49 123 456 789',
            helperText:
              'Telefonisch lässt sich Dein Event erfahrungsgemäß am schnellsten absprechen!',
          },
          notifySimilar: {
            label:
              "Mit Klick auf 'Warteliste beitreten', stimme ich zu bei neuen Terminen kontaktiert zu werden.",
          },
          name: {
            label: 'Vorname',
            placeholder: 'Erika',
          },
          surname: {
            label: 'Nachname',
            placeholder: 'Mustermann',
          },
          numberOfTickets: {
            label: 'Anzahl Teilnehmer',
            placeholder: 'Personenanzahl',
            privateEventError:
              'Für eine Anfrage müsst Ihr mindestens {privateEventMinTickets} sein.',
            dateRequestError:
              'Für eine Anfrage müsst Ihr mindestens {minTicketsDateRequest} sein.',
            errorText:
              'Teilnehmeranzahl zu gering. Bitte frage einen Termin direkt auf einer beliebigen Kursseite an.',
            helperText:
              'Die Personenanzahl ist leider zu klein für eine exklusive Veranstaltung. Du kannst unten nach konkreten Kursen und Veranstaltungen suchen.',
          },
          companyName: {
            label: 'Unternehmensname',
            helperText:
              'Natürlich nur, wenn es sich um eine Firmenanfrage dreht.',
          },
          city: {
            label: 'Stadt',
            helperText: 'Wo soll es stattfinden?',
          },
          dateType: {
            label: 'Als exklusive Veranstaltung anfragen',
            toolTipText:
              'Dieses Event kann nur als private Gruppe angefragt werden.',
          },
          date1: {
            label: 'Termin 1',
            placeholder: 'auswählen',
            helperText:
              'Sofern Du mehrere mögliche Daten hast, gib einfach das an, welches Euch am liebsten ist.',
          },
          date2: {
            label: 'Termin 2',
            placeholder: 'auswählen',
          },
          date3: {
            label: 'Termin 3',
            placeholder: 'auswählen',
          },
          time1: {
            label: 'Uhrzeit 1',
            placeholder: 'auswählen',
          },
          time2: {
            label: 'Uhrzeit 2',
            placeholder: 'auswählen',
          },
          time3: {
            label: 'Uhrzeit 3',
            placeholder: 'auswählen',
          },
          confirmContactCheckbox: {
            label:
              'Mit klicken auf "Abschicken", stimmst Du zu, dass wir Dich kontaktieren.',
          },
        },
      },
      secondStep: {
        title: 'Erfolgreich eingetragen!',
        description: '',
        submitButtonLabel: 'Fenster schließen',
        iconBlockText: 'Geschafft! Wir haben Deine Anfrage erhalten.',
        requestDatesSuccessMessage:
          'Geschafft! Wir haben Deine Anfrage erhalten.',
      },
    },

    addOn: {
      detailsTitle: 'Möchtest Du noch etwas hinzufügen?',
      detailsSubtitle: 'Folgende Produkte kannst Du dazu buchen',
      detailsCTA: 'Datum auswählen und in den Warenkorb legen',
      addOnLabel: 'Add-on',
      addOnPlaceholder: 'Add-on auswählen',
    },

    ticketCardsSection: {
      title: 'Verfügbare Termine',
      perGroup: 'Pro Gruppe',
      perPerson: ' pro Ticket',
      addToCart: 'In den Warenkorb',
    },

    eventLocation: {
      userLocation: 'In meiner Location',
      partnerLocation: 'Location des Veranstalters ({eventLocation})',
    },

    titleByCategory: {
      tour: {
        about: 'Über diese Tour',
        location: 'Adresse - hier startet die Tour:',
      },
      kit: {
        about: 'Über diese Box',
        progress: 'Dieses Erlebnis erwartet Dich in der Box:',
        courseTarget: 'Für wen ist die Box geeignet?',
        whatToBring: 'Was brauchst Du zusätzlich?',
        whatIsIncluded: 'Was beinhaltet die Box?',
      },
      course: {
        about: 'Über diesen Kurs',
        progress: 'Wie läuft der Kurs ab?',
        courseTarget: 'Für wen ist der Kurs geeignet?',
        whatToBring: 'Was Du zum Kurs mitbringen solltest',
        whatIsIncluded: 'Was im Kurs inklusive ist',
        location: 'Adresse - hier findet der Kurs statt:',
        teamEventAndPrivate: 'Teamevents und Gruppen',
      },
      experience: {
        about: 'Über dieses Erlebnis',
        progress: 'Wie läuft das Erlebnis ab?',
        courseTarget: 'Für wen ist das Erlebnis geeignet?',
        whatToBring: 'Was Du mitbringen solltest',
        whatIsIncluded: 'Was inklusive ist',
        teamEventAndPrivate: 'Teamevents und Gruppen',
        location: 'Adresse - hier findet das Erlebnis statt:',
      },
    },

    itemVariety: {
      GROUP_EVENT: 'Gruppenevent',
      TEAM_EVENT: 'Teamevent',
    },
  },
}
